import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Hidden,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPicTreeReviewMethodBySeason,
  getPicTreeReviewSummaryDataBySeason,
  getPicTreeReviewTrendDataBySeason,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import ReviewStatusSummary from "components/PicTree/Review/ReviewStatusSummary";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePickerAll from "components/Calendar/CalendarRangePickerPicTreeAll";
import ChartPictreeReviewTrend from "components/Charts/ChartPicTreeReviewTrend";
import PicTreeTableReview from "components/Table/PicTreeTableReview";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReviewStatus = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  reviewMethodBySeason,
  reviewTrendBySeason,
  getPicTreeReviewMethodBySeason,
  getPicTreeReviewSummaryDataBySeason,
  getPicTreeReviewTrendDataBySeason,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "日別", value: "day" });
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (dateRangePicTree[0] !== null && dateRangePicTree[1]!== null
      && initialDataCall) {
      getPicTreeReviewMethodBySeason();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  useEffect(() => {
    if (reviewMethodBySeason.length > 0) {
      getPicTreeReviewSummaryDataBySeason();
      getPicTreeReviewTrendDataBySeason(chartSize);
    }
  }, [reviewMethodBySeason, chartSize]);

  const handleChange = (event) => {
    setChartSize(event.target.value);
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 全体</Typography>
              <Typography variant="body1">レビュー</Typography>
              <Typography variant="body1">レビュー状況</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePickerAll
              mDate={"2024/09/14"}
              page="pictree"
              pictree
              timeselect={false}
              singleSelect={true}
              maxRange={7}
            />
          </Grid>
        </Grid>

        <Hidden smDown>
          <Grid container justifyContent="center" spacing={0} style={{ marginTop: 0 }}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <CardContent>
                  <div className={classes.cardContentSection}>
                    <ReviewStatusSummary />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Hidden>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item style={{ marginTop: 0, marginLeft: 48, }}>
              <SingleSelect
                selected={chartSize}
                options={[
                  { name: "時間別", value: "hour" },
                  { name: "日別", value: "day" },
                ]}
                handleChange={handleChange}
              />
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12} md={12} lg={12}>
            {pageTopLoader ? (
              <div className={classes.loaderBox}>
                <img
                  className={classes.loaderBarImg}
                  src={`/static/images/loader-bar.gif`}
                />
              </div>
            ) : (
              reviewTrendBySeason !== undefined ? (
                <ChartPictreeReviewTrend />
              ) : (
                <div className={classes.selectGameTxt}>
                  <Chip
                    label="No Data"
                    style={{
                      color: V.textColor,
                      backgroundColor: V.placeholderColor,
                    }}
                  />
                </div>
              )
            )}
          </Grid>
        </Grid>
        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12} md={12} lg={12}>
            <PicTreeTableReview chartSize={chartSize} />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReviewStatus.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  reviewMethodBySeason: state.pictree.reviewMethodBySeason,
  reviewTrendBySeason: state.pictree.reviewTrendBySeason,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPicTreeReviewMethodBySeason: (param) => dispatch(getPicTreeReviewMethodBySeason(param)),
  getPicTreeReviewSummaryDataBySeason: () => dispatch(getPicTreeReviewSummaryDataBySeason()),
  getPicTreeReviewTrendDataBySeason: (param) => dispatch(getPicTreeReviewTrendDataBySeason(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReviewStatus));
